import React from 'react';
import { connect } from 'react-redux';
import {
  PageHeader,
  Grid,
  Row,
  Col,
  Button,
} from 'react-bootstrap';

import AuctionCard from '../components/AuctionCard';
import ZeroState from './ui/ZeroState';

import {
  auctionsGetLive,
  pollAuctionsGetLive,
} from '../util/thunks';

class LiveAuctions extends React.Component {

  componentWillMount() {
    this.props.auctionsGetLive();

    this.interval = setInterval(() => {
      this.props.pollAuctionsGetLive();
    }, 5000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return (
      <div>

        <PageHeader>New Cards</PageHeader>

        {this.props.liveAuctions.length === 0 &&
          <ZeroState bsSize="large">
            <p>No current drops! Come back in a bit!</p>
            <p>While you wait for more drops, check out the marketplace:</p>
            <Button href="https://opensea.io/assets" target="_blank" bsStyle="link">OpenSea Marketplace</Button>
          </ZeroState>
        }

        {this.props.liveAuctions.length > 0 &&
          <Grid>
            <Row>
              {this.props.liveAuctions.map(auction =>
                <Col xs={6} sm={6} md={4} key={auction.auctionIndex}>
                  <AuctionCard auction={auction} />
                </Col>
              )}
            </Row>
          </Grid>
        }

      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    liveAuctions: state.auctions.live,
  };
};

const mapDispatchToProps = (dispatch) => ({

  auctionsGetLive: () => {
    return dispatch(auctionsGetLive());
  },

  pollAuctionsGetLive: () => {
    return dispatch(pollAuctionsGetLive());
  },

});

export default connect(mapStateToProps, mapDispatchToProps)(LiveAuctions);



// WEBPACK FOOTER //
// ./src/components/LiveAuctions.js